module.exports = __webpack_public_path__ + "static/img/h8-1.4f71d61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h8-1.png
// module id = 0TWv
// module chunks = 1